import React from 'react'

import GoToSessionButton from './go_to_session_button'

const SessionBookConfirmation = (props) => {
  if (props.expert && props.currentUser && props.bookData.requestData.get('type') === 'immediate') {
    return (
      <div className='book-session'>
        <div className='section'>
          <h4>You are all set!</h4>
          <p>Go to your session to start it now.</p>
        </div>
        <div className='section' style={{maxWidth: '400px', marginTop: 40}}>
          <GoToSessionButton sessionId={props.bookData.sessionId}/>
        </div>
      </div>
    )
  }
  else {
    // TODO: implement future booking sessions confirmation.
    return (
      <div className='book-session'>
        <div className='section'>
          <h4>You're all set! Here's what happens next...</h4>
        </div>
        <div className='section'>
          <div className='gray-box' style={{paddingLeft: 20}}>
            <ul style={{textAlign: 'left'}}>
              <li>You and {props.expert.get('name')} will receive an email notification confirming your expert advice session... </li>
              <li>1 day and 1 hour before your session, you'll receive an email reminder...</li>
              <li>Show up ON TIME to maximize {props.expert.get('name')}'s time!</li>
              <li>If your chat ends early, you'll be refunded the difference.</li>
            </ul>
          </div>
        </div>
        <div className='section'>
          <p>Thanks for using RotoBaller, the only place for live fantasy advice with real experts!</p>
        </div>
      </div>
    )
  }
}

export default SessionBookConfirmation



/** WEBPACK FOOTER **
 ** ./modules/shared/session_book_confirmation.js
 **/